import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { toast } from '@previo/design-system'
import { useUserStore } from '~/store/user'
import { Routes } from '~/router/routes'

const loadUser = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  try {
    await useUserStore().load()

    return next()
  } catch (e) {
    toast.error(e)

    return next({ name: Routes.GENERAL_SELECT_PROPERTY })
  }
}

export default loadUser
